import { Request, POST, GET, PUT, DELETE, PATCH } from './base';

const GetAllSubscriptionPlans = async () => await Request('/getAllPlans', GET, true);

const CreateSubscription = async (searchParams: any) => await Request('/createSubscription' + searchParams, POST, true);

const subscriptionRest = {
    GetAllSubscriptionPlans,
    CreateSubscription,
};

export default subscriptionRest;